import { mergeRight } from "ramda";

const initialState = {
  provider: {},
  firebase: {},
  idToken: null,
  refreshToken: null,
  token: null,
  passwordChangeProviderDetails: {},
  agoraAppId: null,
};

const sameProviderIdentity = (currentProvider = {}, nextProvider = {}) =>
  (currentProvider?.id != null &&
    nextProvider?.id != null &&
    String(currentProvider.id) === String(nextProvider.id)) ||
  (currentProvider?.userId != null &&
    nextProvider?.userId != null &&
    String(currentProvider.userId) === String(nextProvider.userId));

const saveProvider = (currentProvider, nextProvider) => {
  if (!nextProvider) {
    return {};
  }
  if (sameProviderIdentity(currentProvider, nextProvider)) {
    return mergeRight(currentProvider, nextProvider);
  }
  return nextProvider;
};

export default function providerDetailsReducer(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case "SAVEPROVIDERDETAILS":
      return {
        ...state,
        provider: saveProvider(state.provider, payload),
      };
    case "UPDATEPROVIDERDETAILS":
      return {
        ...state,
        provider: mergeRight(state.provider, payload),
      };
    case "STOREFIREBASEDETAILS":
      return {
        ...state,
        firebase: payload,
      };
    case "STOREIDTOKEN": {
      return {
        ...state,
        idToken: payload,
      };
    }
    case "STOREREFRESHTOKEN": {
      return {
        ...state,
        refreshToken: payload,
      };
    }
    case "PASSWORDPROVIDERDETAILS": {
      return {
        ...state,
        passwordChangeProviderDetails: payload,
      };
    }
    case "AGORAAPPID": {
      return {
        ...state,
        agoraAppId: payload,
      };
    }
    case "STOREPROVIDERTOKEN": {
      return {
        ...state,
        token: payload,
      };
    }
    default:
      return state;
  }
}
